
import {AuthService} from "@/services/auth-service";
import {TicketService} from "@/services/ticket-service";
import {setFaviconDefault, setFaviconNotification} from "@/utils/favicon";
import Vue from "vue";
import AppLogin from "./views/Login.vue";
import AppModalServiceContainer from "@/components/modals/ModalServiceContainer.vue";

export default Vue.extend({
	data() {
		return {
			drawer: true,
			collapsed: true,
			AuthService,
			TicketService
		};
	},
	computed: {
		loggedIn(): boolean {
			return this.AuthService.isLoggedIn;
		},
		ready(): boolean {
			return this.AuthService.ready;
		},
		showNotification(): boolean {
			if (this.TicketService.getUnreadAttentionsEstimate() > 0) {
				return true;
			}
			return false;
		}
	},
	watch: {
		showNotification: {
			immediate: true,
			handler() {
				if (this.showNotification) {
					setFaviconNotification();
				} else {
					setFaviconDefault();
				}
			}
		}
	},
	methods: {
		logout() {
			AuthService.logout();
		},
		hasPermission(permission: string): boolean {
			if (!this.AuthService.user) {
				return false;
			}
			return this.AuthService.user.hasPermission(permission);
		},
		hasSpecialPermission(): boolean {
			//if (this.AuthService.user?.id == 1 || this.AuthService.user?.id == 32) {
			if(!this.AuthService.user){
				return false;
			}
			if (([1,32,48,49,55].indexOf(this.AuthService.user.id) > -1)) {
				return true;
			}
			return false;
		}
	},
	created() {
		AuthService.$on("request-error", (msg: string) => {
			this.$wf.notify(msg, "danger", 5000, "exclamation-triangle");
		});
	},
	components: {
		AppLogin,
		AppModalServiceContainer
	},
});
